import { useEffect, useState } from "react";
import Model from "@tripian/model";
import { providers } from "@tripian/core";

const useTravelify = (
  latitude?: number,
  longitude?: number,
  arrivalDatetime?: string,
  departureDatetime?: string,
  numberOfAdults?: number,
  numberOfChildren?: number
) => {
  const isTravelifyActive =
    typeof window !== "undefined" &&
    window.tconfig &&
    Array.isArray(window.tconfig.TOUR_TICKET_PROVIDER_IDS)
      ? window.tconfig.TOUR_TICKET_PROVIDER_IDS.includes(
          Model.PROVIDER_ID.TRAVELIFY
        )
      : false;

  const [travelifyUrl, setTravelifyUrl] = useState<string>();
  const [loadingTravelify, setLoadingTravelify] =
    useState<boolean>(isTravelifyActive);

  useEffect(() => {
    if (
      window.tconfig.TOUR_TICKET_PROVIDER_IDS.includes(
        Model.PROVIDER_ID.TRAVELIFY
      ) &&
      providers.travelify &&
      latitude &&
      longitude &&
      arrivalDatetime &&
      departureDatetime &&
      window.tconfig.SHOW_TOURS_AND_TICKETS
    ) {
      setLoadingTravelify(true);

      providers.travelify
        .getTourTicketUrl(
          arrivalDatetime,
          departureDatetime,
          latitude,
          longitude
        )
        .then((url: string) => {
          setTravelifyUrl(url);
        })
        .catch(travelifyFetchToursError => {
          console.error(
            "Travelify Fetch Tours Error:",
            travelifyFetchToursError
          );
          setTravelifyUrl(undefined);
        })
        .finally(() => setLoadingTravelify(false));
    }
  }, [
    latitude,
    longitude,
    arrivalDatetime,
    departureDatetime,
    numberOfAdults,
    numberOfChildren,
  ]);

  return {
    travelifyUrl,
    loadingTravelify,
  };
};

export default useTravelify;
